import { createEntityAdapter } from "@reduxjs/toolkit";
import { PageContent } from "./dataTypes";

export const pageContentAdapter = createEntityAdapter<PageContent>({});
